import { memo } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background: #f3f3f3;
  height: calc(100vh - 60px);
  margin-top: 60px;
  padding-top: 20px;
  overflow: hidden;
  position: relative;
`

export default memo(Container)
